import { menuWidth, shrunkMenuWidth } from "@saleor/components/Siderbar";
import { makeStyles } from "@saleor/macaw-ui";

interface propsType {
  expandMenu?: boolean;
  bodyPaddingRight?: number;
}

export const bottomFixed = 80;
const useStyles = makeStyles<propsType>(
  theme => ({
    textWhite: {
      color: "white"
    },
    root: {
      overflowX: "auto",
      width: "100%",
      marginBottom: `${bottomFixed}px`,
      borderRadius: 6,
      border: "1px solid #E0E0E0"
    },
    boxCustomer: {
      borderRadius: 6,
      background: "#FFF",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
      overflow: "hidden",
      margin: "1.6rem 0"
    },
    boxHeader: {
      padding: "1.7rem 2.4rem",
      background: theme.palette.gardient.medium,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      color: "#FFF"
    },
    headerTitle: {
      color: "#FFF"
    },
    headerId: {
      fontSize: 20
    },
    boxBody: {
      padding: "2.4rem"
    },
    infoRow: {
      display: "flex",
      alignItems: "center",
      borderRadius: 6,
      padding: 5,
      margin: "5px 0",
      fontSize: 14
    },
    infoLeft: {
      marginRight: 5
    },
    infoRight: {
      marginLeft: "auto",
      textAlign: "right"
    },
    tableProduct: {
      marginTop: 30
    },
    mainTable: {
      borderCollapse: "collapse",
      "& .MuiTableRow-root": {
        background: "#FFF",
        "&:hover": {
          background: "#FFF !important"
        },
        "&:nth-child(even)": {
          background: "#FFF"
        }
      },
      "& .MuiFormControl-root": {
        height: 34
      }
    },
    tableTitle: {
      marginBottom: 20,
      display: "flex",
      alignItems: "center",
      height: 50
    },
    btnDelete: {
      marginRight: 16,
      padding: "12px",
      "&.Mui-disabled": {
        "& path": {
          stroke: "#e0e0e0",
          strokeWidth: "2"
        }
      }
    },
    bottomBar: {
      position: "fixed",
      bottom: 0,
      boxShadow: "0px -8px 24px rgba(0, 0, 0, 0.08)",
      background: "#FFF",
      borderTopLeftRadius: 20,
      borderTopRightRadius: 20,
      padding: "2rem 2.4rem",
      height: 90,
      width: props =>
        props.expandMenu
          ? `calc(100% - ${menuWidth}px - 50px - ${props.bodyPaddingRight}px)`
          : `calc(100% - ${shrunkMenuWidth}px - 50px - ${props.bodyPaddingRight}px)`,
      display: "flex",
      alignItems: "center"
    },
    barRight: {
      marginLeft: "auto",
      display: "flex",
      alignItems: "center"
    },
    btnOrder: {
      marginLeft: "4.8rem",
      "& .MuiButton-root": {
        padding: "1rem 6.7rem"
      }
    },
    colorIconTrash: {
      "& path": {
        stroke: "#FF2600",
        strokeWidth: "2"
      }
    },
    tableRow: {
      borderTop: "2px solid white"
    },
    table: {
      borderCollapse: "collapse"
    },
    customerName: {
      color: theme.palette.grey[900]
    },
    colNumber: {
      color: theme.palette.grey[900]
    },
    colProductName: {
      color: theme.palette.grey[900],
      fontWeight: "bold"
    },
    colTrash: {
      "& button": {
        background: "none",
        border: "none",
        padding: 0,
        display: "inline-flex"
      }
    },
    name: {
      color: theme.palette.grey[900],
      fontWeight: "bold"
    },
    textError: {
      color: theme.palette.error.light,
      marginTop: 5
    }
  }),
  { name: "ShoppingCartDetail" }
);
export default useStyles;
